export default {
  errors: null,
  orders: [],
  loading: false,
  count: 0,
  totalCount: 0
};
